import { render, staticRenderFns } from "./retur-table.vue?vue&type=template&id=380950c2&"
import script from "./retur-table.vue?vue&type=script&lang=js&"
export * from "./retur-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports